module.exports = __webpack_public_path__ + "static/aws-sysops-e67d6457e5485797fc0fc4047ba208d5.png";